//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"AutoWallSelection",1,0],[0,"BladeBlendGeometry",0,"CAM.MultiBladeBaseGeometry",0],[0,"BladeGeometry",0,"CAM.MultiBladeBaseGeometry",0],[0,"BlankSpunOutline",0,"CAM.SpunOutlineGeom",0],[0,"CutVolumeGeom",0,"CAM.CutVolumeGeom",0],[0,"FloorPlane",1,"Plane",0],[0,"HoleBossGeom",0,"CAM.HoleBossGeom",0],[0,"HubGeometry",0,"CAM.MultiBladeBaseGeometry",0],[0,"PartSpunOutline",0,"CAM.SpunOutlineGeom",0],[0,"ShroudGeometry",0,"CAM.MultiBladeBaseGeometry",0],[0,"SplittersGeometry",0,"CAM.MultiBladeSplittersGeometry",0]],[],[]];
SPLM.CAM.GeometryCiBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GeometryCiBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;